// METIS Hub wording — namespace "glossary" (ko), 209 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/glossary.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const glossary: Record<string, string> = {
  "glossary.kicker": "용어 {n}개 · 핵심 {core}개",
  "glossary.desc": "쉬운 말을 크게, 원래 용어와 정의를 함께 보여 줘요. 화면의 점선 밑줄 용어를 누르면 여기로 와요.",
  "glossary.search.label": "용어 찾기",
  "glossary.search.ph": "쉬운 말·원래 용어·영문·변수 이름 (예: 캐시, input_tokens, ㅅㅇㄹ)",
  "glossary.search.hint": "Enter를 누르면 최근 검색에 남아요 · Esc로 지워요 · 초성(ㅅㅇㄹ)으로도 찾아요",
  "glossary.search.clear": "검색어 지우기",
  "glossary.recent": "최근 검색",
  "glossary.recent.clear": "모두 지우기",
  "glossary.recent.local": "이 브라우저에만 남아요",
  "glossary.recent.cleared": "최근 검색을 지웠어요",
  "glossary.popular": "자주 찾는 말",
  "glossary.cat.label": "분류",
  "glossary.cat.all": "전체",
  "glossary.index.label": "가나다 색인",
  "glossary.index.button": "가나다 색인",
  "glossary.index.buttonOn": "색인: {l}",
  "glossary.index.clear": "색인 풀기",
  "glossary.index.sheet": "첫 글자로 찾기",
  "glossary.index.letter": "‘{l}’로 시작하는 용어 {n}개",
  "glossary.status.browse": "분류마다 핵심 용어 {core}개를 먼저 보여 줘요. 보조 용어 {extra}개는 ‘더 보기’로 펼쳐요.",
  "glossary.status.cat": "{cat} {n}개 중 핵심 용어 {core}개를 먼저 보여 줘요.",
  "glossary.status.query": "‘{q}’{wa} 맞는 용어 {n}개",
  "glossary.status.queryCat": "‘{q}’{wa} 맞는 용어 {n}개 · {cat}만",
  "glossary.status.letter": "‘{l}’로 시작하는 용어 {n}개",
  "glossary.status.letterCat": "‘{l}’로 시작하는 용어 {n}개 · {cat}만",
  "glossary.sec.count": "핵심 {core} · 보조 {extra}",
  "glossary.sec.system": "이 시스템이 화면에서 처음 만든 말이에요. 외부 문서 대신 사용 설명서 절로 이어져요(준비 중).",
  "glossary.more": "보조 용어 {n}개 더 보기",
  "glossary.less": "보조 용어 접기",
  "glossary.item.example": "예시",
  "glossary.item.related": "관련 용어",
  "glossary.item.screens": "쓰이는 화면",
  "glossary.item.ext": "외부 설명",
  "glossary.item.detail": "자세히 보기",
  "glossary.item.edit": "고치기",
  "glossary.item.hidden": "숨김 · 관리자만 보여요",
  "glossary.match.plain": "쉬운 말과 일치",
  "glossary.match.chosung": "초성과 일치",
  "glossary.match.term": "원래 용어와 일치",
  "glossary.match.alias": "다른 이름과 일치",
  "glossary.match.raw": "원래 이름과 일치",
  "glossary.match.def": "정의에 있어요",
  "glossary.match.renamed": "화면에서는 ‘{plain}’{rago} 불러요",
  "glossary.none.title": "‘{q}’에 맞는 용어가 없어요",
  "glossary.none.desc": "철자를 확인하거나 더 짧은 낱말·초성으로 찾아보세요.",
  "glossary.none.similar": "비슷한 용어",
  "glossary.none.dropCat": "‘{cat}’ 분류를 빼면 {n}개",
  "glossary.none.dropLetter": "색인을 풀면 {n}개",
  "glossary.empty.title": "보여 줄 용어가 없어요",
  "glossary.empty.desc": "용어 데이터가 아직 들어오지 않았어요. 화면의 점선 밑줄 용어 설명은 그대로 볼 수 있어요.",
  "glossary.error.title": "용어집을 불러오지 못했어요",
  "glossary.error.desc": "잠시 뒤 다시 시도하세요. 화면의 점선 밑줄 용어 설명은 그대로 볼 수 있어요.",
  "glossary.allTerms": "모든 용어 보기",
  "glossary.foot": "정의는 외부 링크 없이도 이해되게 썼어요. 외부 설명은 새 탭으로 열리고, 회사 주소·사용자 정보를 넘기지 않아요.",
  "glossary.foot.check": "외부 링크 점검: 주 1회 · 마지막 {last} · 다음 {next}",
  "glossary.foot.cov": "도구·사용 방식마다 무엇이 남고 무엇은 못 남는지는",
  "glossary.foot.covLink": "무엇이 기록되나요에서 봐요",
  "glossary.ext.checked": "마지막 확인 {date}",
  "glossary.ext.none": "외부 설명이 없는 용어예요. 정의만으로 이해되게 썼어요.",
  "glossary.ext.otherLang": "{lang} 문서",
  "glossary.d.core": "핵심 용어",
  "glossary.d.extra": "보조 용어",
  "glossary.d.orig": "원래 용어: {term}",
  "glossary.d.q.def": "‘{plain}’{eun} 무슨 뜻인가요?",
  "glossary.d.tech.def": "정의 · 예시 · 원래 이름",
  "glossary.d.def": "정의",
  "glossary.d.example": "예시",
  "glossary.d.raw": "원래 이름",
  "glossary.d.rawHint": "기록·설정 파일에는 이 이름으로 보여요(찾기에서도 이 이름으로 찾을 수 있어요).",
  "glossary.d.q.related": "함께 알면 좋은 말은?",
  "glossary.d.tech.related": "관련 용어 {n}개",
  "glossary.d.relatedNone": "이어진 용어가 없어요.",
  "glossary.d.q.screens": "어느 화면에서 보이나요?",
  "glossary.d.tech.screens": "쓰이는 화면 {n}곳",
  "glossary.d.screensNone": "특정 화면에 묶이지 않은 일반 용어예요.",
  "glossary.d.screenLocked": "지금 역할로는 열 수 없어요",
  "glossary.d.screenLogin": "로그인 화면",
  "glossary.d.q.ext": "더 자세한 설명은 어디 있나요?",
  "glossary.d.tech.ext": "외부 설명 · 출처 · 언어 · 마지막 확인",
  "glossary.d.ext.source": "출처",
  "glossary.d.ext.lang": "문서 언어",
  "glossary.d.ext.checked": "마지막 확인",
  "glossary.d.ext.manual": "사용 설명서 절",
  "glossary.d.ext.manualSoon": "{ref} · 준비 중이라 링크를 숨겼어요",
  "glossary.d.ext.rule": "외부 설명은 새 탭에서 열리고, 회사 주소·사용자 정보를 넘기지 않아요. 링크가 깨지면 링크만 숨기고 정의는 그대로 보여요.",
  "glossary.d.copy": "링크 복사",
  "glossary.d.copied": "용어 링크를 복사했어요",
  "glossary.d.oldSlug": "옛 주소({old})로 들어와서 새 주소({slug})로 바꿨어요.",
  "glossary.d.nav": "같은 분류의 다른 용어",
  "glossary.d.prev": "앞 용어",
  "glossary.d.next": "다음 용어",
  "glossary.d.emptyWhat": "이 용어의 설명을 아직 받지 못했어요.",
  "glossary.d.emptyNot": "용어가 없다는 뜻은 아니에요. 잠시 뒤 다시 열어 보세요.",
  "glossary.d.hiddenNote": "목록에서 숨긴 용어예요. 옛 링크로 들어온 사람에게는 계속 보여요.",
  "glossary.u.title": "찾는 용어가 없어요",
  "glossary.u.desc": "‘{slug}’ 주소에 맞는 용어가 없어요. 주소 낱말로 찾은 용어를 보여 줘요.",
  "glossary.u.q": "이 중에 찾던 말이 있나요?",
  "glossary.u.tech": "주소 낱말로 찾은 용어 {n}개",
  "glossary.u.none": "주소 낱말로도 찾지 못했어요. 용어집에서 검색해 보세요.",
  "glossary.u.back": "용어집 전체 보기",
  "glossary.a.add": "용어 추가",
  "glossary.a.links": "링크 점검 결과",
  "glossary.a.linksBad": "확인 필요 {n}",
  "glossary.ls.ok": "정상",
  "glossary.ls.check_needed": "확인 필요",
  "glossary.ls.moved": "주소 바뀜",
  "glossary.ls.pending": "준비 중",
  "glossary.l.kicker": "용어집 관리",
  "glossary.l.title": "외부 링크 점검 결과",
  "glossary.l.sum": "외부 설명·사용 설명서 링크 {n}개 중 정상 {ok}개, 확인 필요 {bad}개, 점검 대기 {p}개예요.",
  "glossary.l.when": "주 1회 자동 점검 · 마지막 {last} · 다음 {next}",
  "glossary.l.rule": "HTTP 200이고, 문서 제목에 기대한 제목이 있고, ‘없는 문서’ 표지가 없어야 정상이에요.",
  "glossary.l.col.term": "용어",
  "glossary.l.col.host": "주소",
  "glossary.l.col.result": "결과",
  "glossary.l.col.why": "까닭",
  "glossary.l.why.title": "문서 제목이 기대와 달라요(없는 문서 표지 감지)",
  "glossary.l.now": "지금 점검",
  "glossary.l.checking": "점검하는 중…",
  "glossary.l.done": "점검을 마쳤어요 · 확인 필요 {n}개",
  "glossary.l.donePending": "점검을 마쳤어요 · 확인 필요 {n}개 · 점검 대기 {p}개",
  "glossary.l.progress": "링크 점검 중 {i}/{n}",
  "glossary.l.bg": "[지금 점검]을 누르면 이 창을 닫고 뒤에서 점검해요. 진행은 화면 아래 알림에 보여요.",
  "glossary.l.noFail": "확인이 필요한 링크가 없어요.",
  "glossary.l.pending": "점검 대기 중인 링크가 있어요. 모든 링크의 결과가 확인된 것은 아니에요.",
  "glossary.l.userView": "사용자 화면에서는 이 링크만 숨기고 정의는 그대로 보여요.",
  "glossary.l.fix": "고치기",
  "glossary.e.kicker": "용어 편집 · {slug}",
  "glossary.e.newKicker": "용어집 관리",
  "glossary.e.title": "‘{plain}’ 고치기",
  "glossary.e.titleNew": "새 용어 추가",
  "glossary.e.tab.label": "용어 편집 단계",
  "glossary.e.tab.edit": "고치기",
  "glossary.e.tab.preview": "미리보기",
  "glossary.e.tab.history": "이력",
  "glossary.e.slug": "주소 이름(slug)",
  "glossary.e.slugHint": "영문 소문자·숫자·하이픈만 써요. 한 번 정하면 바꿀 수 없어요.",
  "glossary.e.slugFixed": "주소 이름은 바꿀 수 없어요({slug}). 이름이 바뀌면 다른 이름(별칭)에 넣으세요.",
  "glossary.e.plainKo": "쉬운 말(한국어)",
  "glossary.e.plainEn": "쉬운 말(영어)",
  "glossary.e.plainLocked": "라벨 사전과 이어진 말이라 여기서 바꿀 수 없어요. 화면 라벨과 용어집이 갈리지 않게 라벨 사전에서 바꿔요.",
  "glossary.e.termKo": "원래 용어(한국어)",
  "glossary.e.termEn": "원래 용어(영어)",
  "glossary.e.defKo": "정의(한국어)",
  "glossary.e.defEn": "정의(영어)",
  "glossary.e.defHint": "1~2문장 · 외부 링크 없이도 이해되게 · 굵게(**글**)·목록(줄 앞에 - )·코드(`글`)는 쓸 수 있어요 · HTML·링크는 안 돼요",
  "glossary.e.exKo": "예시(한국어)",
  "glossary.e.exEn": "예시(영어)",
  "glossary.e.aliases": "다른 이름(별칭)",
  "glossary.e.aliasesHint": "쉼표로 나눠요. 찾기에만 쓰이고 화면에는 보이지 않아요.",
  "glossary.e.related": "관련 용어(주소 이름)",
  "glossary.e.relatedHint": "쉼표로 나눠요. 예: token, cache-read",
  "glossary.e.screens": "쓰이는 화면",
  "glossary.e.category": "분류",
  "glossary.e.core": "핵심 용어",
  "glossary.e.coreDesc": "첫 화면에 먼저 보여요",
  "glossary.e.urlKo": "외부 설명 주소(한국어 문서)",
  "glossary.e.urlEn": "외부 설명 주소(영문 문서)",
  "glossary.e.urlHint": "https 주소만 받아요. 한국어 화면은 한국어 문서를, 영문 화면은 영문 문서를 먼저 보여요. 저장하면 곧바로 링크 점검을 한 번 해요.",
  "glossary.e.source": "출처 이름",
  "glossary.e.expected": "기대하는 문서 제목",
  "glossary.e.err.required": "꼭 넣어야 해요",
  "glossary.e.err.html": "HTML·링크는 넣을 수 없어요(굵게·목록·코드 서식은 돼요)",
  "glossary.e.err.https": "https로 시작하는 주소만 넣을 수 있어요",
  "glossary.e.err.slug": "영문 소문자·숫자·하이픈만 써요",
  "glossary.e.err.slugTaken": "이미 있는 주소 이름이에요",
  "glossary.e.err.related": "없는 용어예요: {list}",
  "glossary.e.err.fix": "고칠 곳이 {n}개 있어요",
  "glossary.e.save": "저장",
  "glossary.e.add": "추가",
  "glossary.e.hide": "숨기기",
  "glossary.e.unhide": "다시 보이기",
  "glossary.e.hideLocked": "라벨 사전이 가리키는 용어라 숨길 수 없어요.",
  "glossary.e.saved": "저장했어요 · 열람·변경 이력에 남았어요",
  "glossary.e.savedCheck": "저장했어요 · 링크 점검을 통과해 외부 링크가 보여요",
  "glossary.e.noChange": "바뀐 곳이 없어요",
  "glossary.e.hidden": "용어를 목록에서 숨겼어요",
  "glossary.e.unhidden": "용어를 다시 보이게 했어요",
  "glossary.e.added": "용어를 추가했어요 · 열람·변경 이력에 남았어요",
  "glossary.e.preview": "사용자 화면의 용어집 목록에서 이렇게 보여요. 굵게·목록·코드 서식도 그대로 보여요.",
  "glossary.h.seed": "처음 데이터(용어 시드)",
  "glossary.h.edit": "고침",
  "glossary.h.revert": "되돌림",
  "glossary.h.hide": "숨김",
  "glossary.h.unhide": "다시 보임",
  "glossary.h.current": "지금 판",
  "glossary.h.fields": "바뀐 칸: {list}",
  "glossary.h.toThis": "이 판으로 되돌리기",
  "glossary.h.reverted": "이전 판으로 되돌렸어요 · 열람·변경 이력에 남았어요",
  "glossary.h.note": "모든 변경은 열람·변경 이력에도 남아요(누가·언제·바뀐 칸).",
  "glossary.e.pcOnly": "PC에서 편집해 주세요",
  "glossary.e.pcOnlyDesc": "용어 편집은 넓은 화면에서 해요. 여기서는 지금 내용만 볼 수 있어요.",
  "glossary.f.plainKo": "쉬운 말(한국어)",
  "glossary.f.plainEn": "쉬운 말(영어)",
  "glossary.f.term": "원래 용어(한국어)",
  "glossary.f.termEn": "원래 용어(영어)",
  "glossary.f.defKo": "정의(한국어)",
  "glossary.f.defEn": "정의(영어)",
  "glossary.f.exKo": "예시(한국어)",
  "glossary.f.exEn": "예시(영어)",
  "glossary.f.aliases": "다른 이름",
  "glossary.f.related": "관련 용어",
  "glossary.f.screens": "쓰이는 화면",
  "glossary.f.category": "분류",
  "glossary.f.core": "핵심",
  "glossary.f.urlKo": "외부 주소(한국어)",
  "glossary.f.urlEn": "외부 주소(영문)",
  "glossary.f.source": "출처",
  "glossary.f.expected": "기대 제목",
  "glossary.f.hidden": "숨김",
  "glossary.f.noUrl": "정하지 않음",
};

export default glossary;
